import { getRequest, patchRequest, postRequest, deleteRequest } from 'services/requests';

export default {
    findCourse: (id) => getRequest(`/courses/${id}`),
    listCourses: () => getRequest(`/courses`),
    listLTIUsers: (body) => postRequest(`/list-lti-users`, body),
    createLTIUsers: (body) => postRequest(`/create-lti-users`, body),
    getGroupSets: (body) => postRequest(`/get-group-sets`, body),
    updateCourse: (id, body) => patchRequest(`/courses/${id}`, body),
    findCourseAccounts: (id) => getRequest(`/courses/${id}/accounts`),
    findCourseUsers: (id) => getRequest(`/courses/${id}/users`),
    findCourseInstructors: (id) => getRequest(`/courses/${id}/instructors`),
    findCourseChannels: (id) => getRequest(`/courses/${id}/channels`),
    readAllChannels: (id) => getRequest(`/courses/${id}/read-all`),
    findCourseActivities: (id, filter = null, orderBy = null, skip = null, top = null) =>
        getRequest(
            `/courses/${id}/activities?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        ),
    findCourseGroups: (id) => getRequest(`/courses/${id}/groups`),
    findCourseSharedUrls: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/shared-urls?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listCourseTasks: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/tasks?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    findCourseFiles: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/files?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    findCourseAuthorities: (id) => getRequest(`/courses/${id}/authorities`),
    findCourseContributions: (id) => getRequest(`/courses/${id}/contributions`),
    findCourseDistributions: (id) => getRequest(`/courses/${id}/distributions`),
    findCourseVariances: (id) => getRequest(`/courses/${id}/variances`),
    findCourseDraft: (id) => getRequest(`/courses/${id}/drafts`),
    listGroupStatuses: (id) => getRequest(`/courses/${id}/group-statuses`),
    listTaskTemplates: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/task-templates?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listMilestones: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/courses/${id}/milestones?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    listPeerEvaluations: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/peer-evaluations?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listSubmissions: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/courses/${id}/submissions?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    listLTIAssignments: (body) => postRequest(`/list-lti-assignments`, body),
    createLTIAssignmentSubmissions: (body) => postRequest('/publish-grades', body),
    createCourseTasks: (id, body) => postRequest(`/courses/${id}/tasks`, body),
    createCourseSharedUrls: (id, body) => postRequest(`/courses/${id}/shared-urls`, body),
    createCourseGroups: (id, body) => postRequest(`/courses/${id}/groups`, body),
    createCourseFiles: (id, body) => postRequest(`/courses/${id}/files`, body),
    createCourseChannels: (id, body) => postRequest(`/courses/${id}/channels`, body),
    createCourseActivities: (id, body) => postRequest(`/courses/${id}/activities`, body),
    createCoursePeerEvaluation: (id, body) => postRequest(`/courses/${id}/peer-evaluations`, body),
    createCourseSubmission: (id, body) => postRequest(`/courses/${id}/submissions`, body),
    upsertCourseDraft: (id, body) => postRequest(`/courses/${id}/drafts`, body),
    createCourseTaskTemplate: (id, body) => postRequest(`/courses/${id}/task-templates`, body),
    createCourseMilestone: (id, body) => postRequest(`/courses/${id}/milestones`, body),
    updateCourseDraft: (id, body) => patchRequest(`/courses/${id}/drafts`, body),
    createCourseSubmission: (id, body) => postRequest(`/courses/${id}/submissions`, body),
    updateCourseSubmission: (id, body) => patchRequest(`/courses/${id}/submissions`, body),
    listCourseSubmissions: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/submissions?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    updateCoursePeerEvaluation: (id, body) => patchRequest(`/courses/${id}/peer-evaluations`, body),
    deleteCourseSubmission: (id, body) => deleteRequest(`/courses/${id}/submissions`, body),
    deleteCoursePeerEvaluation: (id, body) => deleteRequest(`/courses/${id}/peer-evaluations`, body),
};
